import { CoreTextResourceEnglish } from "./core-text-ressource-english";
import { CoreTextResourceSpanish } from "./core-text-ressource-spanish";

export const langRessources = [ CoreTextResourceEnglish, CoreTextResourceSpanish ]